module.exports = __webpack_public_path__ + "h5/static/img/foxex-logo.af25fadd.png";